<form [formGroup]="repairLocationSearchTextForm">
  <div>
    <mc-input
      hiddenlabel
      placeholder="Search for a repair location"
      fit="small"
      ngDefaultControl
      formControlName="SearchText"
      (keyup.enter)="applySearchTextFilters()"
      icon="magnifying-glass"
      [clearbutton]="true"
      (clearbuttonclick)="applySearchTextFilters()">
    </mc-input>
  </div>
</form>
